var IndexController = function() {
    this.MvItemsHover = require('../module/MvItemsHover');
    this.MvSwiper = require('../module/MvSwiper');
    this.ScrollMagic = require('ScrollMagic');
    this.getScrollScene = require('../module/getScrollScene');
    this.InfiniteScroll = require('../module/InfiniteScroll');
    this.Parallax = require('../module/Parallax');
    this.init();
};

IndexController.prototype = {
    init: function() {
        //pc時のslider
        var mvItemsHover = new this.MvItemsHover();
        mvItemsHover.init();

        // SP MainVisual
        var mvSwiper = new this.MvSwiper();
        mvSwiper.init();

        //scene controller
        var controller = new ScrollMagic();
        //scene option
        var option = {
            triggerElement: '#js-mainvisual',
            triggerHook: 'onLeave',
            offset: $('#js-mainvisual').height(),
            reverse: true
        };

        var scene = this.getScrollScene(controller, option);
        require('../module/scene-globalHeader')(scene);

        //infiniteScroll & Parallax
        var infiniteScroll = new this.InfiniteScroll();
        var parallax = new this.Parallax();
        var $window = $(window);
        var trigger;

        mvSwiper.setParallax(parallax);

        var scrollHandler = function(){
            if(trigger){
                clearTimeout(trigger);
            }
            trigger = setTimeout(function(){
                if(infiniteScroll.checkPosition()){
                    infiniteScroll.load(function() {
                        parallax.reset();
                    });
                }
            }, 200);
            parallax.scroll();
        }
        var resizeHandler = function(){
            parallax.reset();
            infiniteScroll.resize();
        }
        var loadHandler = function(){
            infiniteScroll.set($('.js-infinite-scroll'));
            parallax.init();
            parallax.scroll();

            $('.mainvisual-bg-img').on('mainVisualChanged', function() {
                parallax.scroll();
            })

            $window.on('scroll', scrollHandler);
            $window.on('resize', resizeHandler);
        }
        $window.on('load', loadHandler);
    }
};

module.exports = IndexController;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/controller/IndexController.js
 **/